import Swiper from 'swiper/bundle';


if ($('.slider-type-2').length) {
	$('.slider-type-2').each(function() {
		var $this = $(this);
		var section = $(this).closest('section');
		window.sliderType2 = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			speed: 600,
			autoHeight: false,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			loop: true,
			navigation: false,
			on: {
				init: function () {
					var uid = $this.find('.swiper-slide-active').attr('data-slide');
					var currentSlideContent = section.find('[data-slide-content="' + uid + '"]');
					section.find('[data-slide-content]').attr('data-revealed', 'false')
					currentSlideContent.attr('data-revealed', 'true')

					let maxHeight = 0;
					section.find('[data-slide-content] .block-content').each(function() {
						let contentHeight = $(this).outerHeight();
						if (contentHeight > maxHeight) {
							maxHeight = contentHeight;
						}
					});
					section.find('[data-slide-content] .block-content').css('height', maxHeight);

					let maxHeightRow = 0;
					section.find('[data-slide-content] .row').each(function() {
						let contentHeight = $(this).outerHeight();
						if (contentHeight > maxHeightRow) {
							maxHeightRow = contentHeight;
						}
					});
					section.find('[data-slide-content] .row').css('height', maxHeightRow);
				},
				slideChangeTransitionStart: function (swiper) {
					var uid = $this.find('.swiper-slide-active').attr('data-slide');
					var currentSlideContent = section.find('[data-slide-content="' + uid + '"]');
					section.find('[data-slide-content]').attr('data-revealed', 'false')
					currentSlideContent.attr('data-revealed', 'true')
				},
			},
		});
	})
}


if ($('.slider-type-3').length) {
	$('.slider-type-3').each(function() {
		var section = $(this).closest('section');
		window.sliderType3 = new Swiper($(this)[0], {
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 0,
			speed: 600,
			autoHeight: false,
			autoplay: {
				delay: 3000,
				disableOnInteraction: false,
			},
			loop: true,
			navigation: {
				nextEl: section.find('.link-icon-next')[0],
				prevEl: section.find('.link-icon-prev')[0],
			},
		});
	})
}